<template>
    <div class="head">
        <div class="title">
            <h1>مخاطبین</h1>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Contacts'
}
</script>